import { EmailFolder } from '../../hooks/useEmailAPI';

interface FolderListProps {
  folders: EmailFolder[];
  loading: boolean;
  selectedFolderId: string;
  onSelectFolder: (folderId: string) => void;
}

const FolderList = ({ folders, loading, selectedFolderId, onSelectFolder }: FolderListProps) => {
  // Default folders if API doesn't return them
  const defaultFolders: EmailFolder[] = [
    { id: 'INBOX', name: 'Inbox', unreadCount: 0, totalCount: 0 },
    { id: 'SENT', name: 'Sent', unreadCount: 0, totalCount: 0 },
    { id: 'DRAFT', name: 'Drafts', unreadCount: 0, totalCount: 0 },
    { id: 'TRASH', name: 'Trash', unreadCount: 0, totalCount: 0 }
  ];
  
  // Combine API folders with defaults, prioritizing API data
  const displayFolders = folders.length > 0 ? folders : defaultFolders;
  
  if (loading) {
    return (
      <div className="p-4">
        <div className="animate-pulse space-y-2">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="h-10 bg-gray-100 rounded"></div>
          ))}
        </div>
      </div>
    );
  }
  
  return (
    <div className="space-y-1">
      {displayFolders.map((folder) => (
        <div
          key={folder.id}
          className={`px-4 py-2 rounded-lg cursor-pointer flex justify-between items-center ${
            selectedFolderId === folder.id
              ? 'bg-[#ff8c42] text-white'
              : 'hover:bg-[#fff5eb] text-[#694e42]'
          }`}
          onClick={() => onSelectFolder(folder.id)}
        >
          <div className="font-medium">{folder.name}</div>
          {folder.unreadCount > 0 && (
            <div className={`text-xs px-2 py-0.5 rounded-full ${
              selectedFolderId === folder.id
                ? 'bg-white text-[#ff8c42]'
                : 'bg-[#ff8c42] text-white'
            }`}>
              {folder.unreadCount}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FolderList;